import { get } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import "./SalDeclaration.css";
import { Col, Row, Typography } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { formatNumber } from "../../../utils/utilities";
import dayjs from "dayjs";
const { Text } = Typography;

const Detail = () => {
  const { t } = useTranslation();
  const order = useSelector((state) => get(state.OrdersDuck, "order", {}));
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", {}));

  return (
    <>
      {/** View for large screens */}
      <Row className="mb-1em hidden-small">
        <Col span={4}>
          <Text strong>{t("salDeclaration.detail.progressiveData")}</Text>
        </Col>
        <Col span={6}></Col>
        <Col offset={4} span={4}>
          <Text strong>{t("salDeclaration.detail.currentMonth")}</Text>
        </Col>
        <Col span={6}></Col>
      </Row>
      <Row className="mb-1em hidden-small">
        <Col span={4}>
          <Text>{t("salDeclaration.detail.orderValue")}</Text>
        </Col>
        <Col span={6} className="right">
          <div className="boxValue">
            {formatNumber({ value: order.netValue, lang: currentLanguage, suffix: "EUR" })}
          </div>
        </Col>
        <Col offset={4} span={4}>
          <Text>{t("salDeclaration.detail.month")}</Text>
        </Col>
        <Col span={6} className="right">
          <div className="boxValue">{dayjs(order.month && order.month.toString(), "YYYYMM").format("MM/YYYY")}</div>
        </Col>
      </Row>
      <Row className="mb-1em hidden-small">
        <Col span={4}>
          <Text>{t("salDeclaration.detail.workApproved")}</Text>
        </Col>
        <Col span={6} className="right">
          <div className="boxValue">
            {formatNumber({ value: order.approvedValue, lang: currentLanguage, suffix: "EUR" })}
          </div>
        </Col>
        <Col offset={4} span={4}>
          <Text>{t("salDeclaration.detail.monthWorkDeclared")}</Text>
        </Col>
        <Col span={6} className="right">
          <div className="boxValue">
            {formatNumber({ value: order.monthValue, lang: currentLanguage, suffix: "EUR" })}
          </div>
        </Col>
      </Row>
      <Row className="mb-1em hidden-small">
        <Col span={4}>
          <Text>{t("salDeclaration.detail.residualValue")}</Text>
        </Col>
        <Col span={6} className="right">
          <div className="boxValue">
            {formatNumber({ value: order.residualValue, lang: currentLanguage, suffix: "EUR" })}
          </div>
        </Col>
        <Col offset={4} span={4}>
          <Text>{t("salDeclaration.detail.monthWorkApproved")}</Text>
        </Col>
        <Col span={6} className="right">
          <div className="boxValue">
            {formatNumber({ value: order.approvedMonthValue, lang: currentLanguage, suffix: "EUR" })}
          </div>
        </Col>
      </Row>
      <Row className="mb-1em hidden-small">
        <Col span={4}></Col>
        <Col span={6}></Col>
        <Col offset={4} span={4}>
          <Text>{t("salDeclaration.detail.unapprovedWork")}</Text>
        </Col>
        <Col span={6} className="right">
          <div className="boxValue">
            {order.alert ? <WarningOutlined className="PFred mr-10px" /> : ""}
            {formatNumber({ value: order.refutedMonthValue, lang: currentLanguage, suffix: "EUR" })}
          </div>
        </Col>
      </Row>
      {/** View for small screens */}
      <Row className="hidden-large mb-1em">
        <Col className="mb-1em">
          <Text strong>{t("salDeclaration.detail.progressiveData")}</Text>
        </Col>
      </Row>
      <Row className="hidden-large mb-1em">
        <Col span={24} className="mb-1em">
          <Text>{t("salDeclaration.detail.orderValue")}</Text>
        </Col>
        <Col span={24} className="mb-1em right">
          <div className="boxValue">
            {formatNumber({ value: order.netValue, lang: currentLanguage, suffix: "EUR" })}
          </div>
        </Col>
      </Row>
      <Row className="hidden-large mb-1em">
        <Col span={24} className="mb-1em">
          <Text>{t("salDeclaration.detail.workApproved")}</Text>
        </Col>
        <Col span={24} className="mb-1em right">
          <div className="boxValue">
            {formatNumber({ value: order.approvedValue, lang: currentLanguage, suffix: "EUR" })}
          </div>
        </Col>
      </Row>
      <Row className="hidden-large mb-1em">
        <Col span={24} className="mb-1em">
          <Text>{t("salDeclaration.detail.residualValue")}</Text>
        </Col>
        <Col span={24} className="mb-1em right">
          <div className="boxValue">
            {formatNumber({ value: order.residualValue, lang: currentLanguage, suffix: "EUR" })}
          </div>
        </Col>
      </Row>
      <Row className="hidden-large mb-1em">
        <Col span={24} className="mb-1em">
          <Text strong>{t("salDeclaration.detail.currentMonth")}</Text>
        </Col>
      </Row>
      <Row className="hidden-large mb-1em">
        <Col span={24} className="mb-1em">
          <Text>{t("salDeclaration.detail.month")}</Text>
        </Col>
        <Col span={24} className="mb-1em right">
          <div className="boxValue">{dayjs(order.month && order.month.toString(), "YYYYMM").format("MM/YYYY")}</div>
        </Col>
      </Row>
      <Row className="hidden-large mb-1em">
        <Col span={24} className="mb-1em">
          <Text>{t("salDeclaration.detail.monthWorkDeclared")}</Text>
        </Col>
        <Col span={24} className="mb-1em right">
          <div className="boxValue">
            {formatNumber({ value: order.monthValue, lang: currentLanguage, suffix: "EUR" })}
          </div>
        </Col>
      </Row>
      <Row className="hidden-large mb-1em">
        <Col span={24} className="mb-1em">
          <Text>{t("salDeclaration.detail.monthWorkApproved")}</Text>
        </Col>
        <Col span={24} className="mb-1em right">
          <div className="boxValue">
            {formatNumber({ value: order.approvedMonthValue, lang: currentLanguage, suffix: "EUR" })}
          </div>
        </Col>
      </Row>
      <Row className="hidden-large mb-1em">
        <Col span={24} className="mb-1em">
          <Text>{t("salDeclaration.detail.unapprovedWork")}</Text>
        </Col>
        <Col span={24} className="mb-1em right">
          <div className="boxValue">
            {order.alert ? <WarningOutlined className="PFred mr-10px" /> : ""}
            {formatNumber({ value: order.refutedMonthValue, lang: currentLanguage, suffix: "EUR" })}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Detail;
